module.exports = __webpack_public_path__ + "static/media/Radiance.b596f4be.png";